import React from 'react';
import cn from 'classnames';

type BadgeColor = 'black';

const badgeColorClassNames: Record<BadgeColor, string> = {
  black: 'bg-black text-white',
};

interface BadgeProps {
  color: BadgeColor;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({ children, color }) => {
  return (
    <div
      className={cn(
        'rounded-full px-4 py-1 max-h-content',
        badgeColorClassNames[color],
      )}
    >
      {children}
    </div>
  );
};
